<template>
    <div>
        <el-form :inline="true" class="forTbFilter">
            <el-form-item label="操作时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getBgdRechargeListHandler">查询</el-button>
                <el-button type="success" plain icon="el-icon-money" @click="showRecharge">excle充值</el-button>
                <el-button type="primary" plain icon="el-icon-money" @click="showRecharge1">号段充值</el-button>
                <el-button type="primary" plain icon="el-icon-money" @click="showRecharge2">卡号充值</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%;"
            :header-cell-style="{ background: '#f5f5f5' }">
            <el-table-column prop="startIccid" label="ICCID开始号段" align="center"></el-table-column>
            <el-table-column prop="endIccid" label="ICCID结束号段" align="center"></el-table-column>
            <el-table-column prop="insertPkgTotal" label="导入数量" width="80" align="center"></el-table-column>
            <el-table-column prop="insertPkgSuccess" label="成功数量" width="80" align="center"></el-table-column>
            <el-table-column prop="insertPkgFail" label="失败数量" width="80" align="center"></el-table-column>
            <el-table-column prop="pkgName" label="套餐名称" align="center"></el-table-column>
            <el-table-column label="生效时间" width="80" align="center">
                <template v-slot="scope">{{ scope.row.isNextMonth == '0' ? '本月' : '次月' }}</template>
            </el-table-column>
            <el-table-column label="充值总金额（元）" width="120" align="center">
                <template v-slot="scope">{{ scope.row.totalPrice / 100 }}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="操作时间" width="150" align="center"></el-table-column>
            <el-table-column prop="createOptName" label="操作人" align="center"></el-table-column>
            <el-table-column label="操作" width="150" align="center" fixed="right">
                <template slot-scope="scope" v-if="scope.row.insertPkgFail > 0">
                    <el-button type="text" @click="getBgdRechargeFailListHandler(scope.row.id, $event)">查看失败</el-button>
                    <el-button type="text" @click="exportInfoHandle(scope.row.id)">导出记录</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true" title="批量充值" :visible.sync="rechargeVisible" width="600px"
            :close-on-click-modal="false">
            <el-form ref="rechargeForm" :model="rechargeForm" :rules="rechargeFormRules" label-width="130px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/invest/list')" :data="rechargeForm"
                        :headers="setHeader()" :auto-upload="false" :on-success="handleSuccess" :on-change="handleChange">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=invest')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="套餐组：" prop="typeGroupId">
                    <el-select v-model="rechargeForm.typeGroupId" @change="changeHandler" filterable>
                        <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="套餐名称：" prop="packageId">
                    <el-select v-model="rechargeForm.packageId" clearable>
                        <el-option v-for="item in pkgList" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生效时间：" prop="isNextMonth">
                    <el-select v-model="rechargeForm.isNextMonth" clearable>
                        <el-option value="0" label="本月生效"></el-option>
                        <el-option value="1" label="次月生效"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="代理商：">
                    <el-select v-model="rechargeForm.agentId" filterable>
                        <el-option v-for="item in agentListOption" :value="item.id" :key="item.id"
                            :label="item.name + '（' + item.sysUserAccountName + '）'"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否收到款项：" prop="isPay">
                    <el-radio-group v-model="rechargeForm.isPay">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="购买上游套餐：" prop="toBuy">
                    <el-radio-group v-model="rechargeForm.toBuy">
                        <el-radio :label="2">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="备注" prop="remark">
                    <el-input v-model="rechargeForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureRechargeHandler">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="号段充值" :visible.sync="rechargeVisible1" width="600px"
            :close-on-click-modal="false">
            <el-form ref="rechargeForm" :model="rechargeForm" :rules="rechargeFormRules" label-width="130px">
                <el-form-item label="开始ICCID" prop="startIccid" v-if="rechargeForm.isBatch == 0">
                    <el-input v-model="rechargeForm.startIccid" placeholder="支持虚拟号段" clearable></el-input>
                </el-form-item>
                <el-form-item label="结束ICCID" prop="endIccd" v-if="rechargeForm.isBatch == 0">
                    <el-input v-model="rechargeForm.endIccd" placeholder="支持虚拟号段" clearable
                        @change="seletBaseGroupIccid"></el-input>
                </el-form-item>

                <el-form-item label="充值卡号：" class="iccid_textarea_range" v-if="rechargeForm.isBatch == 1">
                    <el-input type="textarea" :rows="2" placeholder="请输入1个或多个虚拟号或者ICCID号,多个请用逗号、空格、或者换行分隔"
                        v-model="rechargeForm.batchIccid" @change="selectDefault()">
                    </el-input>
                </el-form-item>


                <el-form-item label="套餐组：" prop="typeGroupId">
                    <el-select v-model="rechargeForm.typeGroupId" @change="changeHandler" filterable>
                        <el-option v-for="item in pkgGroups" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="套餐名称：" prop="packageId">
                    <el-select v-model="rechargeForm.packageId" clearable>
                        <el-option v-for="item in pkgList" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生效时间：" prop="isNextMonth">
                    <el-select v-model="rechargeForm.isNextMonth" clearable>
                        <el-option value="0" label="本月生效"></el-option>
                        <el-option value="1" label="次月生效"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="代理商：">
                    <el-select v-model="rechargeForm.agentId" filterable>
                        <el-option v-for="item in agentListOption" :value="item.id" :key="item.id"
                            :label="item.name + '（' + item.sysUserAccountName + '）'"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否收到款项：" prop="isPay">
                    <el-radio-group v-model="rechargeForm.isPay">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="购买上游套餐：" prop="toBuy">
                    <el-radio-group v-model="rechargeForm.toBuy">
                        <el-radio :label="2">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="备注" prop="remark">
                    <el-input v-model="rechargeForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel1">取 消</el-button>
                <el-button type="primary" @click="sureRechargeHandler1">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="充值失败记录" :visible.sync="failVisible" width="1000px"
            :close-on-click-modal="false" @close="cancel">

            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号"></el-table-column>
                <el-table-column prop="intoNo" label="接入号"></el-table-column>
                <el-table-column prop="createTime" label="出错时间"></el-table-column>
                <el-table-column prop="failReason" label="失败原因"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage" :page-sizes="[10, 50, 100, 500]" :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>
    </div>
</template>

<script>
import { getBgdRechargeList, getBgdRechargeFailList, getBgdRechargeList1, getBgdRechargeList2 } from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data() {
        return {
            searchForm: {
                time: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            //批量充值 
            rechargeVisible: false,
            rechargeVisible1: false,
            rechargeForm: {
                isBatch: '',
                batchIccid: '',
                typeGroupId: '',
                packageId: '',
                isNextMonth: '0',
                isPay: 0,
                toBuy: 1,
                agentId: '',
                remark: '',
                startIccid: '',
                endIccd: ''
            },
            rechargeFormRules: {
                typeGroupId: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                packageId: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                isNextMonth: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                isPay: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                toBuy: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
            },
            //批量充值  end

            agentListOption: [],
            pkgGroup: [],
            pkgGroups: [],
            pkgList: [],
            failVisible: false,     //查看失败
            currentId_fail: '',
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            rechargeRules: {}
        }
    },
    methods: {
        selectDefault() {
            common.sysRequest('sim/select/group/iccid', this.rechargeForm, 'post').then(res => {
                if (res.data.code === '200') {
                    //this.groupName = res.data.data.groupName;
                    this.rechargeForm.typeGroupId = res.data.data.groupId;
                    var data = {
                        typeGroupId: this.rechargeForm.typeGroupId
                    }
                    common.getPkgOfGroupCom(this, 'pkgList', data);
                }
            });
        },
        seletBaseGroupIccid() {
            common.sysRequest('pkg/group/list/iccid', { 'iccid': this.rechargeForm.startIccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.pkgGroups = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        cancel() {
            this.rechargeVisible = false;
            this.rechargeVisible1 = false;
        },

        cancel1() {
            this.rechargeVisible = false;
            this.rechargeVisible1 = false;
            this.rechargeForm.startIccid = '';
            this.rechargeForm.endIccd = '';
            this.rechargeForm.typeGroupId = '';
            this.rechargeForm.packageId = '';
            this.pkgGroups = [];
            this.pkgGroup = [];
            this.pkgList = [];

        },
        getBgdRechargeListHandler($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getBgdRechargeList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        getBgdRechargeFailListHandler(id, $event) {
            this.failVisible = true;
            this.currentId_fail = id;
            var data = {
                'recordId': id
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', data);

            getBgdRechargeFailList(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        showRecharge() {
            this.rechargeVisible = true;
            common.getPkgGroupListCom(this, 'pkgGroup');
        },
        showRecharge1() {
            this.rechargeForm.isBatch = 0;
            this.rechargeVisible1 = true;
            common.getPkgGroupListCom(this, 'pkgGroup');
        },
        showRecharge2() {
            this.rechargeForm.isBatch = 1;
            this.rechargeVisible1 = true;
            common.getPkgGroupListCom(this, 'pkgGroups');

        },
        changeHandler() {
            this.rechargeForm.packageId = '';
            var data = {
                typeGroupId: this.rechargeForm.typeGroupId
            }
            common.getPkgOfGroupCom(this, 'pkgList', data);
        },
        sureRechargeHandler() {
            if (this.$refs.upload.uploadFiles.length == 0) {
                this.$message.error('请选择文件');
                return;
            }
            this.$refs.rechargeForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();
                }
            });
        },
        sureRechargeHandler1() {

            var data = this.rechargeForm;
            getBgdRechargeList1(data).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('导入完成！');
                    this.getImportRecordListHandle();
                    this.importCardVisible1 = false;
                } else {
                    this.$message.error(res.data.message);
                }
            })


        },

        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }
        },

        handleSuccess(res, file, fileList) {
            console.log("-----------------------------------")
            console.log(file)
            console.log(fileList)

            if (res.code == 200) {
                this.rechargeVisible = false;
                this.getBgdRechargeListHandler();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
            this.$refs.upload.clearFiles();
        },
        handleSizeChange(val) {
            if (this.failVisible) {
                this.tbpg_fail.pageSize = val;
                this.getBgdRechargeFailListHandler(this.currentId_fail);
            } else {
                this.tbpg.pageSize = val;
                this.getBgdRechargeListHandler();
            }
        },
        handleCurrentChange(val) {
            if (this.failVisible) {
                this.tbpg_fail.currentPage = val;
                this.getBgdRechargeFailListHandler(this.currentId_fail);
            } else {
                this.tbpg.currentPage = val;
                this.getBgdRechargeListHandler();
            }
        },



        exportInfoHandle(recordId) {
            common.sysRequest('export/exportBatchInvestPkgFailRecord', { 'recordId': recordId }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success('数据导出中,请稍候去任务中心下载');
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
    },
    created() {
        this.getBgdRechargeListHandler();
        common.getAgentListOptionCom(this, 'agentListOption');
    }
}
</script>

<style lang="less" scoped></style>

